export default {
  routeDetails: {
    'routeDetails': 'Detalles de la ruta',
    'warnings': 'Avisos',
    'routes': 'Rutas',
    'route': 'Ruta',
    'segments': 'Segmentos',
    'segment': 'Segmento',
    'instructions': 'Instrucciones',
    'instruction': 'Instrucción',
    'name': 'Nombre',
    'selectRoute': 'Seleccionar esta ruta',
    'selectedRoute': 'Ruta seleccionada',
    'gotoSegment': 'Ir para segmento',
    'warningCodes': {
      '1': 'Puede haber algunas restricciones en las carreteras que forman parte de la ruta',
      '2': 'Hay peajes a lo largo de la ruta',
      '3': 'Hay uno o más segmentos que se han dibujado como una línea recta a lo largo de la ruta. Las duraciones y la accesibilidad pueden no ser correctas',
      '4': 'No se dispone de al menos un dato adicional solicitado'
    },
    'routeOpacity': 'Opacidad de ruta'
  }
}
